import { useRoute, useRouter } from 'vue-router'

type UseChatMessageLinksOptions = {
	// открыть карточку счёта по клику на ссылку #bill/<Id>
	onOpenBill: (billId: number) => void
	// вызывается после перехода на карточку клиента/проекта:
	// панели в шапке нужно закрыть модалку чата, иначе она перекроет карточку
	onNavigated?: () => void
}

export function useChatMessageLinks(options: UseChatMessageLinksOptions) {
	const router = useRouter()
	const route = useRoute()

	const onMessageClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement | null

		const billLink = target?.closest('.chat-bill-link') as HTMLElement | null
		if (billLink?.dataset.billId) {
			event.preventDefault()
			event.stopPropagation()
			options.onOpenBill(Number(billLink.dataset.billId))
			return
		}

		const entityLink = target?.closest('.chat-entity-link') as HTMLElement | null
		if (!entityLink) {
			return
		}

		if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) {
			return
		}

		const page = entityLink.dataset.entityPage
		const id = entityLink.dataset.entityId
		if (!page || !id) {
			return
		}

		event.preventDefault()
		event.stopPropagation()

		const onMainPage = route.path === '/main'
		if (onMainPage && route.query.page === page && String(route.query.id) === id) {
			options.onNavigated?.()
			return
		}

		router.push({
			path: '/main',
			query: onMainPage ? { ...route.query, page, id } : { page, id },
		})
		options.onNavigated?.()
	}

	return { onMessageClick }
}
